import { jsx, setClassToken } from '@amzn/shiv'
import type { RecommendationModel } from '@/browse/recommendationModel'
import { createImageModel } from '@/util/ImageUrl'
import { ImageView } from '@/components/ImageView'
import { ImagePlaceholder } from '@/components/ImagePlaceholder'
import { ImageSizes } from '@/style/styleCommon'
import { toast } from '@/components/toast'
import { Icon } from '@/components/Icon'
import { data } from '@amzn/vinyl-observable'
import { navigateTo } from '@/router/router'
import { addToSession, getSessionId } from '@/party/partySessionService'

const addedIds = data(new Set<string>())

export function PartyResultItem({ data: item }: { data: RecommendationModel }) {
    const id = item.id ?? ''
    const isNavigable = item.type === 'Album' || item.type === 'Artist'

    const resizedImage = createImageModel(item.image, {
        scaleToSquare: ImageSizes.SMALL,
    })

    const handleClick = () => {
        if (item.type === 'Album') navigateTo(`/album/${id}`)
        else if (item.type === 'Artist') navigateTo(`/artist/${id}`)
    }

    const view = (
        <div
            className={`recommendation type-${item.type}${isNavigable ? ' clickable' : ''}`}
            onclick={isNavigable ? handleClick : undefined}
            onConnect={() =>
                addedIds.onData((ids) => {
                    setClassToken(view, 'disabled', ids.has(id))
                })
            }
        >
            <ImageView
                image={resizedImage}
                placeholder={<ImagePlaceholder />}
                loadWhenIdle={true}
            />
            <div className="details">
                <div className={'type'}>{item.type}</div>
                <div className={'title'}>{item.title}</div>
                {item.artistName && <div className={'artistName'}>{item.artistName}</div>}
            </div>
            {isNavigable ? (
                <span className="expandIcon">
                    <Icon icon="caretRight" />
                </span>
            ) : (
                <button
                    className="button addButton"
                    onclick={async (e) => {
                        e.stopPropagation()
                        if (addedIds.value.has(id)) {
                            toast(`"${item.title}" is already added`)
                            return
                        }
                        const sessionId = getSessionId()
                        if (!sessionId) {
                            toast('No session — cannot add track')
                            return
                        }
                        const btn = e.currentTarget as HTMLButtonElement
                        btn.disabled = true
                        const result = await addToSession(sessionId, id, item.title)
                        btn.disabled = false
                        if (result.success) {
                            addedIds.value = new Set([...addedIds.value, id])
                            toast(result.message)
                        } else {
                            toast(result.message)
                        }
                    }}
                >
                    <Icon icon="add" />
                </button>
            )}
        </div>
    )

    return view
}
